/*
 * サブシステム名：経営管理
 * 機能名：貨物NO毎売上明細
 */

import DdNumericBox from '@/components/DdNumericBox'
import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdRadioButton from '@/components/DdRadioButton'
import DdDropDown from '@/components/DdDropDown'
import DdDataTable from '@/components/DdDataTable'
import DdDateBox from '@/components/DdDateBox'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import DdTextBox from '../../components/DdTextBox.vue'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import header from '@/ddv2.library/header'

export default {
  name: 'KamotsuNoUriageList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {},
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    headersHinmeiList: header.mstHinmeiHeaders,
    modeKengen: 0,
    page: 1,
    isCsvDownloader: false,
    isPdfDownloader: false
  }),
  components: {
    DdNumericBox,
    DdSubHeader,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdCodeTextBox,
    DdTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdRadioButton,
    DdDropDown,
    DdDataTable,
    DdDateBox
  },
  computed: {
    filteredRows () {
      return this.rows.map((elem) => {
        // elem.juchuYmdDisp = elem.juchuYmd ? filter.dateFormatter(elem.juchuYmd) : ''
        // elem.seikyuYoteiYmdDisp = elem.seikyuYoteiYmd ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
        // elem.nippoYmdDisp = elem.nippoYmd ? filter.dateFormatter(elem.nippoYmd) : ''
        // elem.jissekiShukkoYmdDisp = elem.jissekiShukkoYmd ? filter.dateFormatter(elem.jissekiShukkoYmd) : ''
        // elem.jissekiKikoYmdDisp = elem.jissekiKikoYmd ? filter.dateFormatter(elem.jissekiKikoYmd) : ''

        // elem.sagyoJikanDisp = elem.sagyoJikan ? filter.minToTimeFormatter(elem.sagyoJikan) : ''
        // elem.kyusokuJikanDisp = elem.kyusokuJikan ? filter.minToTimeFormatter(elem.kyusokuJikan) : ''
        // elem.kadouJikanDisp = elem.kadouJikan ? filter.minToTimeFormatter(elem.kadouJikan) : ''

        // elem.seikyuKingakuDisp = elem.seikyuKingaku === 0 || elem.seikyuKingaku ? filter.numericFormatter(elem.seikyuKingaku) : null
        // elem.uriageKingakuKeiDisp = elem.uriageKingakuKei === 0 || elem.uriageKingakuKei ? filter.numericFormatter(elem.uriageKingakuKei) : null
        // elem.shiharaiKingakuKeiDisp = elem.shiharaiKingakuKei === 0 || elem.shiharaiKingakuKei ? filter.numericFormatter(elem.shiharaiKingakuKei) : null
        // elem.keikakuEnginePriceKeiDisp = elem.keikakuEnginePriceKei === 0 || elem.keikakuEnginePriceKei ? filter.numericFormatter(elem.keikakuEnginePriceKei) : null
        // elem.keikakuHiwayPriceKeiDisp = elem.keikakuHiwayPriceKei === 0 || elem.keikakuHiwayPriceKei ? filter.numericFormatter(elem.keikakuHiwayPriceKei) : null
        // elem.humanPriceKeiDisp = elem.humanPriceKei === 0 || elem.humanPriceKei ? filter.numericFormatter(elem.humanPriceKei) : null
        // elem.keikakuHendoPriceKeiDisp = elem.keikakuHendoPriceKei === 0 || elem.keikakuHendoPriceKei ? filter.numericFormatter(elem.keikakuHendoPriceKei) : null
        // elem.keikakuGenkaiRiekiDisp = elem.keikakuGenkaiRieki === 0 || elem.keikakuGenkaiRieki ? filter.numericFormatter(elem.keikakuGenkaiRieki) : null
        // elem.keikakuRiekiRateDisp = elem.keikakuRiekiRate === 0 || elem.keikakuRiekiRate ? filter.numericMinorDigitFormatter(elem.keikakuRiekiRate, 2) : null
        // elem.uriageKingakuKeiDisp = elem.uriageKingakuKei === 0 || elem.uriageKingakuKei ? filter.numericFormatter(elem.uriageKingakuKei) : null
        // elem.shiharaiKingakuKeiDisp = elem.shiharaiKingakuKei === 0 || elem.shiharaiKingakuKei ? filter.numericFormatter(elem.shiharaiKingakuKei) : null
        // elem.jissekiEnginePriceKeiDisp = elem.jissekiEnginePriceKei === 0 || elem.jissekiEnginePriceKei ? filter.numericFormatter(elem.jissekiEnginePriceKei) : null
        // elem.hiwayPriceKeiDisp = elem.hiwayPriceKei === 0 || elem.hiwayPriceKei ? filter.numericFormatter(elem.hiwayPriceKei) : null
        // elem.jissekiHendoPriceKeiDisp = elem.jissekiHendoPriceKei === 0 || elem.jissekiHendoPriceKei ? filter.numericFormatter(elem.jissekiHendoPriceKei) : null
        // elem.jissekiGenkaiRiekiDisp = elem.jissekiGenkaiRieki === 0 || elem.jissekiGenkaiRieki ? filter.numericFormatter(elem.jissekiGenkaiRieki) : null
        // elem.jissekiRiekiRateDisp = elem.jissekiRiekiRate === 0 || elem.jissekiRiekiRate ? filter.numericMinorDigitFormatter(elem.jissekiRiekiRate, 2) : null
        // elem.anbunJissekiEnginePriceDisp = elem.anbunJissekiEnginePrice === 0 || elem.anbunJissekiEnginePrice ? filter.numericFormatter(elem.anbunJissekiEnginePrice) : null
        // elem.anbunHiwayPriceDisp = elem.anbunHiwayPrice === 0 || elem.anbunHiwayPrice ? filter.numericFormatter(elem.anbunHiwayPrice) : null
        // elem.anbunHumanPriceDisp = elem.anbunHumanPrice === 0 || elem.anbunHumanPrice ? filter.numericFormatter(elem.anbunHumanPrice) : null
        // elem.jissekiHendoPriceDisp = elem.jissekiHendoPrice === 0 || elem.jissekiHendoPrice ? filter.numericFormatter(elem.jissekiHendoPrice) : null

        elem.seikyuYoteiYmdDisp = elem.seikyuYoteiYmd ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
        elem.juchuYmdDisp = elem.juchuYmd ? filter.dateFormatter(elem.juchuYmd) : ''
        elem.seikyuKingakuDisp = elem.seikyuKingaku === null || elem.seikyuKingaku === undefined ? null : filter.numericFormatter(elem.seikyuKingaku)
        elem.uriageKingakuDisp = elem.uriageKingaku === null || elem.uriageKingaku === undefined ? null : filter.numericFormatter(elem.uriageKingaku)
        elem.shiharaiKingakuDisp = elem.shiharaiKingaku === null || elem.shiharaiKingaku === undefined ? null : filter.numericFormatter(elem.shiharaiKingaku)
        elem.anbunKeikakuEnginePriceDisp = elem.anbunKeikakuEnginePrice === null || elem.anbunKeikakuEnginePrice === undefined ? null : filter.numericFormatter(elem.anbunKeikakuEnginePrice)
        elem.anbunKeikakuHiwayPriceDisp = elem.anbunKeikakuHiwayPrice === null || elem.anbunKeikakuHiwayPrice === undefined ? null : filter.numericFormatter(elem.anbunKeikakuHiwayPrice)
        elem.anbunHumanPriceDisp = elem.anbunHumanPrice === null || elem.anbunHumanPrice === undefined ? null : filter.numericFormatter(elem.anbunHumanPrice)
        elem.keikakuHendoPriceDisp = elem.keikakuHendoPrice === null || elem.keikakuHendoPrice === undefined ? null : filter.numericFormatter(elem.keikakuHendoPrice)
        elem.meisaiKeikakuGenkaiRiekiDisp = elem.meisaiKeikakuGenkaiRieki === null || elem.meisaiKeikakuGenkaiRieki === undefined ? null : filter.numericFormatter(elem.meisaiKeikakuGenkaiRieki)
        elem.meisaiKeikakuRiekiRateDisp = elem.meisaiKeikakuRiekiRate === null || elem.meisaiKeikakuRiekiRate === undefined ? null : filter.numericFormatter(elem.meisaiKeikakuRiekiRate)
        elem.uriageKingakuDisp = elem.uriageKingaku === null || elem.uriageKingaku === undefined ? null : filter.numericFormatter(elem.uriageKingaku)
        elem.shiharaiKingakuDisp = elem.shiharaiKingaku === null || elem.shiharaiKingaku === undefined ? null : filter.numericFormatter(elem.shiharaiKingaku)
        elem.anbunJissekiEnginePriceDisp = elem.anbunJissekiEnginePrice === null || elem.anbunJissekiEnginePrice === undefined ? null : filter.numericFormatter(elem.anbunJissekiEnginePrice)
        elem.anbunHiwayPriceDisp = elem.anbunHiwayPrice === null || elem.anbunHiwayPrice === undefined ? null : filter.numericFormatter(elem.anbunHiwayPrice)
        elem.jissekiHendoPriceDisp = elem.jissekiHendoPrice === null || elem.jissekiHendoPrice === undefined ? null : filter.numericFormatter(elem.jissekiHendoPrice)
        elem.meisaiJissekiGenkaiRiekiDisp = elem.meisaiJissekiGenkaiRieki === null || elem.meisaiJissekiGenkaiRieki === undefined ? null : filter.numericFormatter(elem.meisaiJissekiGenkaiRieki)
        elem.meisaiJissekiRiekiRateDisp = elem.meisaiJissekiRiekiRate === null || elem.meisaiJissekiRiekiRate === undefined ? null : filter.numericFormatter(elem.meisaiJissekiRiekiRate)
        elem.nippoYmdDisp = elem.nippoYmd ? filter.dateFormatter(elem.nippoYmd) : ''
        elem.jissekiShukkoYmdDisp = elem.jissekiShukkoYmd ? filter.dateFormatter(elem.jissekiShukkoYmd) : ''
        elem.jissekiKikoYmdDisp = elem.jissekiKikoYmd ? filter.dateFormatter(elem.jissekiKikoYmd) : ''
        elem.sagyoJikanDisp = elem.sagyoJikan ? filter.minToTimeFormatter(elem.sagyoJikan) : ''
        elem.kyusokuJikanDisp = elem.kyusokuJikan ? filter.minToTimeFormatter(elem.kyusokuJikan) : ''
        elem.kadouJikanDisp = elem.kadouJikan ? filter.minToTimeFormatter(elem.kadouJikan) : ''
        elem.anbunJissekiEnginePriceDisp = elem.anbunJissekiEnginePrice === null || elem.anbunJissekiEnginePrice === undefined ? null : filter.numericFormatter(elem.anbunJissekiEnginePrice)
        elem.anbunHiwayPriceDisp = elem.anbunHiwayPrice === null || elem.anbunHiwayPrice === undefined ? null : filter.numericFormatter(elem.anbunHiwayPrice)
        elem.anbunHumanPriceDisp = elem.anbunHumanPrice === null || elem.anbunHumanPrice === undefined ? null : filter.numericFormatter(elem.anbunHumanPrice)
        elem.jissekiHendoPriceDisp = elem.jissekiHendoPrice === null || elem.jissekiHendoPrice === undefined ? null : filter.numericFormatter(elem.jissekiHendoPrice)
        if (elem.sokoKyori) { elem.sokoKyori = filter.numericFormatter(elem.sokoKyori) + ' km' }
        if (elem.jissekiShukkoHms) { elem.jissekiShukkoHms = (elem.jissekiShukkoHms).slice(0, 5) }
        if (elem.jissekiKikoHms) { elem.jissekiKikoHms = (elem.jissekiKikoHms).slice(0, 5) }
        return elem
      })
    },
    isNippoHimoduke () {
      if (this.conditions.nippoHimodukeKbn !== '1') {
        return false
      }
      return true
    },
    isYosha () {
      if (this.conditions.nippoSbt !== '03') {
        return false
      }
      return true
    },
    isRenraku () {
      if (this.conditions.renrakuYn !== '1') {
        return false
      }
      return true
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0 || this.isCsvDownloader
    },
    isPdfButtonDisabled () {
      return this.rows.length === 0 || this.isPdfDownloader
    },
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hinmeiList: 'DDMasters/mstHinmei',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      loginEigyoshoCd: 'users/eigyoshoCd'
    }),
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredYoshasakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.hacchusakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.torihikisakiCd === null && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hinmeiCd > elem2.hinmeiCd) { return 1 }
        if (elem1.hinmeiCd === elem2.hinmeiCd) { return 0 }
        return -1
      })
    },
    filterdOhfukuSbtList () {
      const list = this.kubunList.filter((elem) => elem.kbnShuruiCd === 'SFF052')
        .map((elem) => {
          elem.value = elem.code.trim()
          elem.text = elem.codeNm.trim()
          return elem
        })
      list.unshift({ value: '00', text: '指定有' })
      list.unshift({ value: '99', text: '指定なし' })
      return list
    },
    filterdHinmokuSbtList () {
      const list = this.shubetsuList.filter((elem) => elem.sbtShuruiCd === 'GVIJ02')
        .map((elem) => {
          console.log(elem)
          elem.value = elem.sbtCd.trim()
          elem.text = elem.sbtNm.trim()
          return elem
        })
      list.unshift({ value: '', text: '' })
      return list
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions,
        searchText: this.searchText,
        rows: this.rows
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msteigyosho', 'msthinmei', 'msyskubun', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise((resolve) => {
            console.log('KamotsuNoUriage.defineHeaderPromise')
            self.headers = [
              { text: '売上営業所コード', value: 'sagyoEigyoshoCd' },
              { text: '売上営業所名称', value: 'sagyoEigyoshoNm' },
              { text: '貨物No', value: 'juchuNo' },
              { text: '作業明細番号', value: 'sagyoMeisaiNo' },
              { text: '受注日', value: 'juchuYmdDisp', align: 'center' },
              { text: '受注営業所コード', value: 'juchuEigyoshoCd' },
              { text: '受注営業所名称', value: 'juchuEigyoshoNm' },
              { text: '荷主コード', value: 'ninushiCd' },
              { text: '荷主名称', value: 'ninushiNm' },
              { text: '発地コード', value: 'hatsuchiCd' },
              { text: '発地名称', value: 'hatsuchiNm' },
              { text: '卸先コード', value: 'oroshisakiCd' },
              { text: '卸先名称', value: 'oroshisakiNm' },
              { text: '着地コード', value: 'chakuchiCd' },
              { text: '着地名称', value: 'chakuchiNm' },
              { text: '往復種別', value: 'ohfukuSbtNm' },
              { text: '商品種別', value: 'hinmokuSbtNm' },
              { text: '商品コード', value: 'hinmeiCd' },
              { text: '商品名', value: 'hinmeiNm' },
              { text: '請求計上日', value: 'seikyuYoteiYmdDisp', align: 'center' },
              { text: '請求金額計', value: 'seikyuKingakuDisp', align: 'end' },
              { text: '請求用適用事項', value: 'seikyuBiko' },
              { text: '請求車種', value: 'seikyuShashuSbtNm' },
              { text: 'その他連絡用', value: 'juchuRenrakuBiko' },
              { text: '標準売上金額', value: 'uriageKingakuDisp', align: 'end' },
              { text: '標準支払金額', value: 'shiharaiKingakuDisp', align: 'end' },
              { text: '標準燃料費', value: 'anbunKeikakuEnginePriceDisp', align: 'end' },
              { text: '標準高速代', value: 'anbunKeikakuHiwayPriceDisp', align: 'end' },
              { text: '標準人件費', value: 'anbunHumanPriceDisp', align: 'end' },
              { text: '標準変動費', value: 'keikakuHendoPriceDisp', align: 'end' },
              { text: '標準限界利益', value: 'meisaiKeikakuGenkaiRiekiDisp', align: 'end' },
              { text: '標準利益率', value: 'meisaiKeikakuRiekiRateDisp', align: 'end' },
              { text: '実績売上金額', value: 'uriageKingakuDisp', align: 'end' },
              { text: '実績支払金額', value: 'shiharaiKingakuDisp', align: 'end' },
              { text: '実績燃料費', value: 'anbunJissekiEnginePriceDisp', align: 'end' },
              { text: '実績高速代', value: 'anbunHiwayPriceDisp', align: 'end' },
              { text: '実績人件費', value: 'anbunHumanPriceDisp', align: 'end' },
              { text: '実績変動費', value: 'jissekiHendoPriceDisp', align: 'end' },
              { text: '実績限界利益', value: 'meisaiJissekiGenkaiRiekiDisp', align: 'end' },
              { text: '実績利益率', value: 'meisaiJissekiRiekiRateDisp', align: 'end' },
              { text: '日報No', value: 'nippoNo' },
              { text: '日報日', value: 'nippoYmdDisp', align: 'center' },
              { text: '日報種別', value: 'haishaKbnNm' },
              { text: '連絡事項', value: 'sagyoRenrakuBiko' },
              { text: '乗務員コード', value: 'jomuinCd' },
              { text: '乗務員名', value: 'jomuinNm' },
              { text: '同乗者コード', value: 'dojoshaCd' },
              { text: '同乗者名', value: 'dojoshaNm' },
              { text: '傭車先コード', value: 'yoshasakiCd' },
              { text: '傭車先名', value: 'yoshasakiNm' },
              { text: '車両番号', value: 'sharyoNo' },
              { text: '車両ナンバープレート', value: 'sharyoNoPlate' },
              { text: '車種', value: 'shashuSbtNm' },
              { text: '走行距離', value: 'sokoKyori' },
              { text: '出庫日', value: 'jissekiShukkoYmdDisp', align: 'center' },
              { text: '出庫時刻', value: 'jissekiShukkoHms', align: 'center' },
              { text: '帰庫日', value: 'jissekiKikoYmdDisp', align: 'center' },
              { text: '帰庫時刻', value: 'jissekiKikoHms', align: 'center' },
              { text: '拘束時間', value: 'sagyoJikanDisp', align: 'center' },
              { text: '休憩時間', value: 'kyusokuJikanDisp', align: 'center' },
              { text: '稼働時間', value: 'kadouJikanDisp', align: 'center' },
              { text: '燃料代', value: 'anbunJissekiEnginePriceDisp', align: 'end' },
              { text: '高速代', value: 'anbunHiwayPriceDisp', align: 'end' },
              { text: '人件費', value: 'anbunHumanPriceDisp', align: 'end' },
              { text: '変動費', value: 'jissekiHendoPriceDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            console.log('initializeInputPromise')
            var loginEigyoshoId = 0
            if (self.filteredEigyoshoList) {
              const loginEigyosho = self.filteredEigyoshoList.filter((elem) => {
                return elem.eigyoshoCd === self.loginEigyoshoCd
              })
              if (loginEigyosho.length !== 0) {
                loginEigyoshoId = loginEigyosho[0].id
              }
            }
            const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
            const endDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
            const startYmdString = `${startDate.getFullYear()}/${('0' + (startDate.getMonth() + 1)).slice(-2)}/${('0' + (startDate.getDate())).slice(-2)}`
            const endYmdString = `${endDate.getFullYear()}/${('0' + (endDate.getMonth() + 1)).slice(-2)}/${('0' + (endDate.getDate())).slice(-2)}`
            self.conditions = {
              searchEigyoshoId: loginEigyoshoId,
              ninushiId: null,
              ohfukuSbtKbn: '99',
              seikyuYoteiStartYmd: startYmdString,
              seikyuYoteiEndYmd: endYmdString,
              hinmokuSbt: '',
              hinmeiId: null,
              nippoHimodukeKbn: '9',
              nippoNo: '',
              nippoSbt: '99',
              yoshasakiId: null,
              renrakuYn: '9',
              renrakuBiko: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('KamotsuNoUriage.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('KamotsuNoUriage.savedInputRestorePromise after loadFromCache', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('KamotsuNoUriage.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('KamotsuNoUriage.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCThbzmd0050/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            var loginEigyoshoId = 0
            if (self.filteredEigyoshoList) {
              const loginEigyosho = self.filteredEigyoshoList.filter((elem) => {
                return elem.eigyoshoCd === self.loginEigyoshoCd
              })
              if (loginEigyosho.length !== 0) {
                loginEigyoshoId = loginEigyosho[0].id
              }
            }
            const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
            const endDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
            const startYmdString = `${startDate.getFullYear()}/${('0' + (startDate.getMonth() + 1)).slice(-2)}/${('0' + (startDate.getDate())).slice(-2)}`
            const endYmdString = `${endDate.getFullYear()}/${('0' + (endDate.getMonth() + 1)).slice(-2)}/${('0' + (endDate.getDate())).slice(-2)}`
            self.conditions = {
              searchEigyoshoId: loginEigyoshoId,
              ninushiId: null,
              ohfukuSbtKbn: '99',
              seikyuYoteiStartYmd: startYmdString,
              seikyuYoteiEndYmd: endYmdString,
              hinmokuSbt: '',
              hinmeiId: null,
              nippoHimodukeKbn: '9',
              nippoNo: '',
              nippoSbt: '99',
              yoshasakiId: null,
              renrakuYn: '9',
              renrakuBiko: ''
            }
            self.searchText = ''
            self.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onCsvButtonClick: function (e) {
      this.isCsvDownloader = true
      this.HttpClient.post('/api/v1/VwCThbzmd0050/download', this.conditions).then((data) => {
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        const blob = new Blob([bom, data], { type: 'text/csv' })
        const elem = document.getElementById('download')
        this.isCsvDownloader = false
        elem.href = window.URL.createObjectURL(blob)
        elem.click()
      })
    },
    onPdfButtonClick: function (e) {
      this.isPdfDownloader = true
      this.HttpClient
        .requestFileByPost('/api/v1/VwCThbzmd0050/pdfdownload', this.conditions)
        .then((data) => {
          const blob = new Blob([data], { type: 'application/pdf' })
          const elem = document.getElementById('pdfdownload')
          elem.href = window.URL.createObjectURL(blob)
          this.isPdfDownloader = false
          elem.click()
        })
    },
    searchValidate: function () {
      return true
    }
  }
}
